import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Sidebar, MobileNav } from "./Sidebar";
import { TopBar } from "./TopBar";
import { TrialBanner } from "@/components/launch/TrialBanner";
import { useSession } from "@/context/SessionContext";

export function AppShell({ children }: { children: React.ReactNode }) {
  const { isAuthed } = useSession();
  const location = useLocation();

  if (!isAuthed) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return (
    <div className="min-h-screen bg-background" data-testid="app-shell">
      <Sidebar />
      <div className="lg:pl-[264px]">
        <TrialBanner />
        <TopBar />
        <main className="mx-auto w-full max-w-7xl px-4 pb-28 pt-6 lg:px-8 lg:pb-12">{children}</main>
      </div>
      <MobileNav />
    </div>
  );
}
